(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  function initBlock(block) {
    var items = block.querySelectorAll('[data-plist-items] > .plists__item');
    var more = block.querySelector('[data-plist-more]');
    var limit = parseInt(block.dataset.mobileVisible, 10) || 12;
    var expanded = false;
    if (!items.length) return;
    function apply() {
      if (!mq.matches) {
        items.forEach(function (li) { li.style.display = ''; });
        if (more) more.hidden = true;
        return;
      }
      if (items.length <= limit) {
        items.forEach(function (li) { li.style.display = ''; });
        if (more) more.hidden = true;
        return;
      }
      if (more) more.hidden = false;
      items.forEach(function (li, i) { li.style.display = (expanded || i < limit) ? '' : 'none'; });
    }
    if (more) more.addEventListener('click', function () {
      expanded = !expanded;
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      block.classList.toggle('is-open', expanded);
      apply();
    });
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
    window.addEventListener('resize', apply);
  }
  function all() { document.querySelectorAll('[data-plists] [data-plist-block]').forEach(initBlock); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-plists]')) all(); });
})();
